export const DuplicateSignInAlert = {
    title: [
        "You have another device",
        "already signed in."
    ],
    description: [
        "Signing in from this device will automatically sign out other devices. Are you sure you want to sign in?"
    ],
    button: "Got it"
}

export const NoSignUpAlert = {
    title: [
        "No signup information is available."
    ],
    description: [],
    button: "Got it"
}